import { GetStaticProps } from 'next';
import GlossaryTerms from '../../../../components/glossary_v2/components/TermsPage';
import {
  domainCode,
  LANGUAGE_CODE,
} from '../../../../constants/staticPageConstants';
import {
  staticPageGenerate,
  staticPagesPath,
} from '../../../../utils/static-pages/staticPages';
import {
  ISTATIC_PAGE_PROPS,
  PostData,
} from '../../../../components/cms/layout/types';

const Article = ({ postData }: ISTATIC_PAGE_PROPS): JSX.Element => {
  return (
    <>
      <GlossaryTerms postData={postData as unknown as PostData} />
    </>
  );
};

export const getStaticPaths = async () => {
  if (process.env.DEPLOYMENT_DOMAIN !== 'cleartax.in') {
    return {
      paths: [],
      fallback: false,
    };
  }
  if (process.env.ENABLE_GLOSSARY_PAGES === 'true') {
    const staticPaths = await staticPagesPath(
      LANGUAGE_CODE.English,
      domainCode.cleartaxIn,
      'fs-cache-dbs/cmsDATA.db',
      'glossary'
    );
    return { ...staticPaths };
  }
  return {
    paths: [],
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (process.env.ENABLE_GLOSSARY_PAGES === 'true') {
    const staticPages = await staticPageGenerate(
      params,
      1,
      'fs-cache-dbs/cmsDATA.db',
      'glossary'
    );
    return { ...staticPages };
  } else {
    return {
      props: {
        postData: { title: '' },
      },
    };
  }
};

export default Article;
